import styled from "styled-components";
import { MEDIA_Q } from "../../config/constants/css";

export const StyledUserProfile = styled.div`
  width: 100%;
`;

export const StyledHorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(p) => p.theme.border};
  margin: ${(p) => p.$m ?? "1px 0px"};
`;

export const StyledUserProfileBody = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-top: 12px;

  ${MEDIA_Q.MD} {
    grid-template-columns: 1fr 1fr;
  }
`;
